import { IResponse, requestMachine } from "@/requests/requestMachine";
import {
  InstructionsApi,
} from "../mainApi/apis/InstructionsApi";
import { IInstruction } from '@/requests/mainApi/models/IInstruction';

export default {
  getInstructions(): Promise<IResponse<IInstruction[]>> {
    return requestMachine<IInstruction[]>(
      InstructionsApi,
      "getInstructions",
      true,
    );
  }
};
